import * as React from 'react'
import RippleContainer from '@af-common/Common/_components/RippleContainer'
import { ModuleTypes, Categories } from '../../Module/_config/ModuleInfo'

export type Props = {
	name?: React.ReactNode
	type?: ModuleTypes
	className?: string
	onModuleAdd?: Function
	onModuleAddWithValue?: Function
	subTitle?: React.ReactNode
	icon?: string,
	category?: Categories,
	value?: boolean | string | number
}

enum TileTypes {
	// wider UI, adds only the module
	TYPE_1 = "TYPE_1",
	// wider UI, adds the module and updates module value at the same time
	TYPE_2 = "TYPE_2",
	// default smaller UI, adds only the module
	TYPE_3 = "TYPE_3",
}

export default class ModuleCreatorModule extends React.Component<Props> {
	private getTileType(): TileTypes {
		let moduleType = this.props.type;
		let moduleCategory = this.props.category;
		if (
			moduleType == ModuleTypes.Image ||
			moduleType == ModuleTypes.ImageUpload ||
			moduleType == ModuleTypes.PatternDesignService
		) {
			return TileTypes.TYPE_1;
		} else if (moduleCategory == Categories.Transforms) {
			return TileTypes.TYPE_2;
		} else {
			return TileTypes.TYPE_3;
		}
	}

	render() {
		let style = {
			backgroundImage: "url('static/img/lab/module-icons/"+this.props.type+".png'"
		};
		let tileType = this.getTileType();
		return <>
			{tileType == TileTypes.TYPE_1 && <div onClick={() => this.props.onModuleAdd(this.props.type)}>
				<RippleContainer>
					<div className={this.props.icon == 'add' ? "module-creator__tile long" : "module-creator__tile"}>
						{this.props.icon && <img className="" src={"static/img/icons/" + this.props.icon + "-icon.svg"} alt="" width="50" height="50" />}
						{this.props.name && <span className="module-creator__title">{this.props.name}</span>}
						{this.props.subTitle && <span className="module-creator__sub-title">{this.props.subTitle}</span>}
					</div>
				</RippleContainer>
			</div>}
			{tileType == TileTypes.TYPE_2 && <div onClick={() => this.props.onModuleAddWithValue(this.props.type, 'group', this.props.value)}>
				<RippleContainer>
					<div className="module-creator__tile">
						{this.props.icon && <img className="" src={"static/img/icons/" + this.props.icon + "-icon.svg"} alt="" width="97" height="97" />}
						{this.props.name && <span className="module-creator__title small">{this.props.name}</span>}
						{this.props.subTitle && <span className="module-creator__sub-title">{this.props.subTitle}</span>}
					</div>
				</RippleContainer>
			</div>}
			{tileType == TileTypes.TYPE_3 && <div onClick={() => this.props.onModuleAdd(this.props.type)} style={style} className={"module-creator-module image-card mdc-card mdc-card--outlined " + this.props.className}>
				<RippleContainer>
					<h4><span>{this.props.name}</span></h4>
				</RippleContainer>
			</div>}
		</>
	}
}